var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _ellipse2, _path8, _ellipse3, _path9, _path0, _path1, _path10, _path11, _ellipse4, _ellipse5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131,
    height: 136,
    fill: "none",
    "aria-hidden": "true",
    className: "icon--no-feedback",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3A4374",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.045,
    d: "M62.999 19.636C33.8 19.63 10.126 43.097 10.113 72.056c-.013 28.958 23.641 52.446 52.838 52.466 29.197.021 52.885-23.434 52.913-52.393.016-13.916-5.546-27.268-15.462-37.115-9.916-9.846-23.372-15.378-37.403-15.378Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.714,
    cy: 55.018,
    fill: "#231F20",
    rx: 2.443,
    ry: 3.604
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A4374",
    d: "m.892 56.543 124.174-27.256-24.428-7.067S87.406.465 83.874.011C80.343-.443 16.16 13.135 16.16 13.135l-4.071 30.648L.892 56.543ZM26.744 130.337 12.71 108.33l61.354-10.408 4.213 21.088 6.23-19.422 31.389 6.147-6.382 24.602H26.744Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m105.363 82.616 5.656-.776 2.922 20.939a2.668 2.668 0 0 1-2.293 3.005l-.333.046c-1.47.201-2.826-.817-3.03-2.275l-2.922-20.939Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A4374",
    fillRule: "evenodd",
    d: "M107.783 103.636a3.197 3.197 0 0 0 3.583 2.705l.325-.05a3.18 3.18 0 0 0 2.117-1.222 3.125 3.125 0 0 0 .611-2.352l-2.901-20.937a.472.472 0 0 0-.193-.333.513.513 0 0 0-.377-.101l-5.649.777a.505.505 0 0 0-.437.566l2.921 20.947Zm1.007-.142-2.85-20.442 4.642-.586 2.85 20.443a2.164 2.164 0 0 1-1.853 2.433h-.336a2.187 2.187 0 0 1-2.453-1.848Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m101.019 64.134 9.124-1.252 2.858 20.48-9.124 1.252z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A4374",
    fillRule: "evenodd",
    d: "M103.569 85.03a.553.553 0 0 0 .305.102l.062-.01 9.16-1.252a.506.506 0 0 0 .438-.566l-2.86-20.482a.5.5 0 0 0-.57-.434l-9.161 1.252a.54.54 0 0 0-.336.191.49.49 0 0 0-.091.374l2.86 20.493a.451.451 0 0 0 .193.333Zm.743-.978-2.717-19.484 8.142-1.11 2.718 19.483-8.143 1.11Z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.21,
    height: 35.964,
    fill: "#fff",
    rx: 3.248,
    transform: "rotate(-7.816 776.055 -725.361) skewX(.128)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A4374",
    fillRule: "evenodd",
    d: "M109.87 131.306a3.756 3.756 0 0 0 3.725 3.22l.509.01 2.687-.373c2.051-.287 3.484-2.164 3.206-4.2l-4.071-29.275c-.284-2.038-2.18-3.461-4.234-3.18l-2.687.363a3.792 3.792 0 0 0-2.484 1.444 3.69 3.69 0 0 0-.722 2.766l4.071 29.225Zm1.964-32.829c.126-.01.251-.01.377 0l-.031.01a2.741 2.741 0 0 1 2.708 2.352l4.071 29.276a2.73 2.73 0 0 1-2.341 3.028l-2.687.374a2.755 2.755 0 0 1-3.054-2.322l-4.071-29.275a2.641 2.641 0 0 1 .529-2.02 2.722 2.722 0 0 1 1.812-1.06l2.687-.363Z",
    clipRule: "evenodd"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.852,
    cy: 58.289,
    fill: "#fff",
    rx: 24.458,
    ry: 24.258
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A4374",
    fillRule: "evenodd",
    d: "M79.891 59.406c.607 13.225 11.591 23.64 24.94 23.646 1.164 0 2.327-.078 3.481-.232 13.636-1.913 23.146-14.4 21.272-27.933-1.827-13.114-13.729-22.486-27.022-21.277-13.293 1.208-23.278 12.57-22.671 25.796Zm21.633-24.658a24.37 24.37 0 0 1 3.307-.222h.041c11.93.051 22.01 8.785 23.664 20.503 1.33 9.52-3.255 18.898-11.616 23.76-8.361 4.86-18.85 4.247-26.577-1.554-7.727-5.802-11.17-15.648-8.722-24.949 2.447-9.3 10.303-16.222 19.903-17.538Z",
    clipRule: "evenodd"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.852,
    cy: 58.289,
    fill: "#fff",
    rx: 19.868,
    ry: 19.705
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A4374",
    fillRule: "evenodd",
    d: "M84.497 59.006c.378 10.873 9.375 19.493 20.344 19.493.937.001 1.872-.063 2.799-.192 10.865-1.496 18.581-11.261 17.448-22.083-1.132-10.821-10.707-18.806-21.65-18.056-10.943.75-19.32 9.965-18.941 20.838Zm17.647-19.695c.894-.12 1.795-.181 2.698-.182 10.417.022 18.944 8.224 19.287 18.55.342 10.327-7.625 19.066-18.018 19.767-10.393.7-19.478-6.891-20.547-17.168C84.494 50 91.826 40.73 102.144 39.31Z",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M128.211 112.973a14.816 14.816 0 0 0-4.988-4.038c-5.832-3.028-12.519-2.927-18.656-1.009-2.178.686-6.402 1.666-6.626 4.533a2.667 2.667 0 0 0 1.944 2.523 8.07 8.07 0 0 0 3.409.132 8.857 8.857 0 0 0-4.61 1.15c-1.313.919-2.036 2.928-.957 4.149a3.46 3.46 0 0 0 1.781 1.01 8.204 8.204 0 0 0 4.529-.061 21.259 21.259 0 0 0-4.63 1.444c-.896.394-1.894 1.09-1.792 2.019.102.929 1.018 1.353 1.852 1.635 1.756.598 3.591.938 5.446 1.01a10.78 10.78 0 0 0-4.428 1.887c-2.035 1.696-2.035 4.917.723 5.835a8.189 8.189 0 0 0 2.728.313c8.142 0 17.893-1.009 23.409-7.732a12.473 12.473 0 0 0 2.606-11.418 10.92 10.92 0 0 0-1.74-3.382Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A4374",
    fillRule: "evenodd",
    d: "M101.045 135.647a8.668 8.668 0 0 0 2.829.333l.031.02c8.061-.01 18.056-.919 23.827-7.914a12.934 12.934 0 0 0 2.697-11.892 11.538 11.538 0 0 0-1.842-3.513 15.234 15.234 0 0 0-5.16-4.22c-5.476-2.766-12.245-3.139-19.044-1.009l-.651.191-.068.021c-2.423.737-6.031 1.834-6.263 4.754a3.1 3.1 0 0 0 1.944 2.898c-.36.141-.7.324-1.018.545a4.03 4.03 0 0 0-1.648 2.695c-.12.778.098 1.57.6 2.181a3.844 3.844 0 0 0 2.036 1.15c.18.054.364.097.55.132l-.723.302c-1.405.657-2.189 1.706-2.036 2.575.153.868.835 1.554 2.188 2.019.995.342 2.016.602 3.054.777a7.607 7.607 0 0 0-2.199 1.262 4.382 4.382 0 0 0-1.526 4.038 3.494 3.494 0 0 0 2.422 2.655ZM99.61 123.2a20.103 20.103 0 0 1 3.298-1.141c.427-.05.849-.134 1.262-.252a.516.516 0 0 0 .346-.606.51.51 0 0 0-.591-.374c-.407.081-.824.172-1.231.273a7.883 7.883 0 0 1-3.054-.202 2.964 2.964 0 0 1-1.526-.828 1.795 1.795 0 0 1-.367-1.403 3.025 3.025 0 0 1 1.232-2.019 6.296 6.296 0 0 1 2.941-.949c.236-.005.469-.031.699-.056.247-.028.489-.055.726-.055a.516.516 0 0 0 .458-.545.527.527 0 0 0-.539-.464l-.089.006c-.421.028-.859.057-1.306.105a4.995 4.995 0 0 1-1.822-.222 2.195 2.195 0 0 1-1.608-2.019c.183-2.26 3.455-3.239 5.613-3.885l.006-.002.661-.202c6.545-2.019 13.028-1.666 18.27 1.01a14.087 14.087 0 0 1 4.814 3.937 10.54 10.54 0 0 1 1.69 3.2 11.94 11.94 0 0 1-2.524 10.953c-5.496 6.672-15.196 7.541-23.044 7.541a7.397 7.397 0 0 1-2.554-.283 2.472 2.472 0 0 1-1.751-1.888 3.327 3.327 0 0 1 1.191-3.089 10.645 10.645 0 0 1 4.234-1.787.504.504 0 0 0 .377-.545.498.498 0 0 0-.489-.444 18.576 18.576 0 0 1-5.303-1.009c-.651-.212-1.425-.475-1.506-1.222-.082-.747 1.007-1.322 1.486-1.534Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M71.457 58.673s12.397 18.474 4.896 18.736c-7.501.262-8.143-1.686-8.143-1.686"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A4374",
    d: "M75.01 77.995c-6.29 0-7.197-1.706-7.319-2.02a.534.534 0 0 1 .336-.666.53.53 0 0 1 .662.334s.916 1.564 7.644 1.322c.669.061 1.313-.27 1.648-.848 1.609-3.1-4.478-13.376-6.962-17.07a.522.522 0 0 1 .164-.697.532.532 0 0 1 .712.11c.946 1.414 9.16 13.932 7.023 18.172a2.732 2.732 0 0 1-2.545 1.423l-1.364-.06Z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.982,
    cy: 57.673,
    fill: "#C0C5DC",
    rx: 4.499,
    ry: 7.601
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.928,
    cy: 57.673,
    fill: "#3A4374",
    rx: 3.43,
    ry: 6.148
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFeedback);
export default __webpack_public_path__ + "static/media/no-feedback.036cba8b87da78a50220b446b2d674db.svg";
export { ForwardRef as ReactComponent };